import { render, staticRenderFns } from "./Calc2Confirm.vue?vue&type=template&id=06bedb48&scoped=true&"
import script from "./Calc2Confirm.ts?vue&type=script&lang=ts&"
export * from "./Calc2Confirm.ts?vue&type=script&lang=ts&"
import style0 from "./Calc2Confirm.css?vue&type=style&index=0&id=06bedb48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bedb48",
  null
  
)

export default component.exports